import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Downtime.css";
import Button from "@restart/ui/esm/Button";
import { getDowntimeReasons, queryDB } from "../../../../utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { AuthInfo } from "../../../../App";

export const DowntimeEntry = (props) => {
  const { downtime, queryParams, fetchStatus, setFetchStatus, setShowModal } =
    props;

  let catRef = null;
  let subCatRef = null;
  let codeRef = null;
  //const initialStartTime = new Date(downtime.startTime);
  //const initialEndTime = new Date(downtime.endTime);
  const initialStartTime = new Date(-5.5 * 3600000 + new Date(downtime.startTime).getTime());
  const initialEndTime = new Date(-5.5 * 3600000 + new Date(downtime.endTime).getTime());
  const [startTime, setStartTime] = useState(initialStartTime);
  const [endTime, setEndTime] = useState(initialEndTime);
  const [category, setCategory] = useState(null);
  const [subCategory, setSubCategory] = useState(null);
  const [reasonCode, setReasonCode] = useState(null);
  const [categoryOptions, setCategoryOptions] = useState("");
  const [subCategoryOptions, setSubCategoryOptions] = useState("");
  const [reasonCodeOptions, setReasonCodeOptions] = useState("");
  const [defaultDescription, setDefaultDescription] = useState("");
  const [Description, setDescription] = useState("");
  const { userInfo, userId } = useContext(AuthInfo);

  const onCategoryChange = (sel) => {
    if (sel) {
      setCategory(sel.value);
      setSubCategory(null);
      setReasonCode(null);
      setDefaultDescription("");
      setDescription("");
    }
  };

  const onSubCategoryChange = (sel) => {
    if (sel) {
      setSubCategory(sel.value);
      setReasonCode(null);
      setDefaultDescription("");
      setDescription("");
    }
  };

  const onCodeChange = (sel) => {
    if (sel) {
      setReasonCode(sel.value);
    }
  };

  const onSaveClick = async () => {
    if (
      category == undefined ||
      category == "" ||
      category == "defaultplaceholder"
    ) {
      alert("Please Select Reason Category");
      return;
    }

    if (
      subCategory == undefined ||
      subCategory == "" ||
      subCategory == "defaultplaceholder"
    ) {
      alert("Please Select Reason Sub Category");
      return;
    }

    if (
      reasonCode == undefined ||
      reasonCode == "" ||
      reasonCode == "defaultplaceholder"
    ) {
      alert("Please Select Description [Code]");
      return;
    }

    if (
      reasonCode == undefined ||
      reasonCode == "" ||
      reasonCode == "defaultplaceholder"
    ) {
      alert("Please Select Reason Code");
      return;
    }

    if (
      Description == undefined ||
      Description == "" ||
      Description == "defaultplaceholder"
    ) {
      alert("Please Fill Reason Description");
      return;
    }

    if (queryParams.plantId == undefined || queryParams.plantId == "") {
      alert("Please Select Plant");
      return;
    }

    if (queryParams.lineId == undefined || queryParams.lineId == "") {
      alert("Please Select Line");
      return;
    }

    if (queryParams.machineId == undefined || queryParams.machineId == "") {
      alert("Please Select Machine");
      return;
    }

    let reasonDuration = endTime.getTime() - startTime.getTime();

    if (reasonDuration <= 0) {
      alert("End Time should be after start time.");
      return;
    }

    let reasonDoc = {
      lineId: queryParams.lineId,
      plantId: queryParams.plantId,
      machineID: queryParams.machineId,
      startTime: downtime.startTime,
      endTime: downtime.endTime,
      reasonCode: reasonCode,
      reasonDescrp: Description,
      reasonSubCat: subCategory,
      reasonCat: category,
      defaultReasonDescrp: defaultDescription,
      status: "to be done ...",
      splitInfo: {
        startTimeReason:  new Date(5.5 * 3600000 + new Date(startTime).getTime()),
        endTimeReason:  new Date(5.5 * 3600000 + new Date(endTime).getTime()),
        subReasonDuration: reasonDuration,
      },
      subReasonDurationMinutes: reasonDuration / 60000,
      refresh: true,
      loginInfo : userInfo
    };

    setShowModal(false);

    let resp = await queryDB(
      {
        doc: reasonDoc,
        findQuery: {
          uniqueKey: "doesnotexist",
        },
      },
      "speed",
      "update"
    );

    if (resp.status == 200) {
      setFetchStatus(!fetchStatus);
      toast.success("REASON SAVED", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      toast.error("ERROR OCCURED", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onDeleteClick = async () => {
    if (
      !startTime ||
      !endTime ||
      !queryParams.machineId ||
      queryParams.machineId == ""
    ) {
      alert("incomplete info");
      return;
    }

    let resp = await queryDB(
      {
        doc: {},
        findQuery: {
          machineID: queryParams.machineId,
          startTime: {
            $gte: downtime.startTime.split('.')[0]+'Z',
            $lt: downtime.endTime.split('.')[0]+'Z',
          },
          ignoreUniqueKey: true,
        },
      },
      "speed",
      "delete_many"
    );

    if (resp.status == 200) {
      setFetchStatus(!fetchStatus);
      setShowModal(false);
      toast.warning("REASON DELETED", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      toast.error("ERROR OCCURED", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  useEffect(async () => {
    if (catRef) {
      catRef.clearValue();
    }
    let categoryOptions = [];

    let downtimeURL = getDowntimeReasons();
    let res = await axios.get(downtimeURL);
    res = res.data;

    for (let i = 0; i < res.length; i++) {
      let f1 = false;
      for (let j = 0; j < categoryOptions.length; j++) {
        if (categoryOptions[j]["value"] == res[i]["Category"]) {
          f1 = true;
        }
      }

      if (!f1) {
        categoryOptions.push({
          value: res[i]["Category"],
          label: res[i]["Category"],
        });
      }
    }
    setCategoryOptions(categoryOptions);
  }, []);

  useEffect(async () => {
    if (subCatRef) {
      subCatRef.clearValue();
    }
    let subCategoryOptions = [];

    let downtimeURL = getDowntimeReasons({
      Category: category,
    });

    let res = await axios.get(downtimeURL);
    res = res.data;

    for (let i = 0; i < res.length; i++) {
      let f1 = false;

      for (let j = 0; j < subCategoryOptions.length; j++) {
        if (
          subCategoryOptions[j]["value"] ==
          res[i]["Sub-Category (Breakdown Process)"]
        ) {
          f1 = true;
        }
      }

      if (!f1) {
        subCategoryOptions.push({
          value: res[i]["Sub-Category (Breakdown Process)"],
          label: res[i]["Sub-Category (Breakdown Process)"],
        });
      }
    }

    setSubCategoryOptions(subCategoryOptions);
  }, [category]);

  useEffect(async () => {
    if (codeRef) {
      codeRef.clearValue();
    }

    let reasonCodeOptions = [];

    let downtimeURL = getDowntimeReasons({
      Category: category,
      "Sub-Category (Breakdown Process)": subCategory,
    });

    let res = await axios.get(downtimeURL);
    res = res.data;

    for (let i = 0; i < res.length; i++) {
      let f1 = false;

      for (let j = 0; j < reasonCodeOptions.length; j++) {
        if (reasonCodeOptions[j]["value"] == res[i]["Code"]) {
          f1 = true;
        }
      }

      if (!f1) {
        reasonCodeOptions.push({
          value: res[i]["Code"],
          label: res[i]["Description"] + " " + res[i]["Code"],
        });
      }
    }

    setReasonCodeOptions(reasonCodeOptions);
  }, [category, subCategory]);

  useEffect(async () => {
    let downtimeURL = getDowntimeReasons({
      Category: category,
      "Sub-Category (Breakdown Process)": subCategory,
      Code: reasonCode,
    });

    let res = await axios.get(downtimeURL);
    res = res.data;

    if (res[0]) {
      setDefaultDescription(res[0]["Description"]);
      setDescription(res[0]["Description"]);
    }
  }, [category, subCategory, reasonCode]);


  useEffect(() => {
    if (downtime.reason.length > 0) {
      let endTimeReason = new Date(downtime.reason[downtime.reason.length - 1]["splitInfo"]["endTimeReason"]);
      setStartTime(new Date(-5.5 * 3600000 + new Date(endTimeReason).getTime()));
    }
  }, []);


  return (
    <>
      <DatePicker
        selected={startTime}
        placeholderText={"Downtime Start Time"}
        className={"form-control"}
        dateFormat="MMMM d, yyyy h:mm aa"
        timeFormat="HH:mm"
        onChange={(date) => {
          if (date < initialStartTime) {
            date = initialStartTime;
          }
          if (date > initialEndTime) {
            date = initialEndTime;
          }

          if (downtime.reason.length > 0) {
            let endTimeReason = new Date(downtime.reason[downtime.reason.length - 1]["splitInfo"]["endTimeReason"]);
            if (date < endTimeReason) {
              date = endTimeReason;
            };
          }

          if(date>endTime){
            date = endTime;
          }

          setStartTime(date);
        }}
        showTimeSelect
        timeIntervals={1}
      />
      <br /><br />
      <DatePicker
        placeholderText={"Downtime End Time"}
        selected={endTime}
        className={"form-control"}
        dateFormat="MMMM d, yyyy h:mm aa"
        timeFormat="HH:mm"
        onChange={(date) => {
          if (date < initialStartTime) {
            date = initialStartTime;
          }
          if (date > initialEndTime) {
            date = initialEndTime;
          }
          if (date < startTime) {
            date = startTime;
          }          
          setEndTime(date);
        }}
        showTimeSelect
        timeIntervals={1}
      />
      <br /><br />
      <Select
        ref={(ref) => {
          catRef = ref;
        }}
        placeholder={"Select Category"}
        defaultValue={1}
        options={categoryOptions}
        onChange={onCategoryChange}
        className={"option-overflow"}
      />
      <br />
      <Select
        placeholder={"Select Sub Category"}
        ref={(ref) => {
          subCatRef = ref;
        }}
        defaultValue={1}
        options={subCategoryOptions}
        onChange={onSubCategoryChange}
        className={"option-overflow"}
      />
      <br />
      <Select
        placeholder={"Select Reason Type and Code"}
        ref={(ref) => {
          codeRef = ref;
        }}
        defaultValue={1}
        options={reasonCodeOptions}
        onChange={onCodeChange}
        className={"option-overflow"}
      />
      <br />
      <textarea
        placeholder={"Additional Comments"}
        id="w3review"
        className="form-control"
        name="w3review"
        rows="4"
        cols="50"
        value={Description}
        onChange={(e) => {
          setDescription(e.target.value);
        }}
      ></textarea>
      <br />
      <div className="text-center">
        <Button className="btn btn-danger" onClick={onDeleteClick}>Delete</Button>&nbsp;&nbsp;
        <Button className="btn btn-primary" onClick={onSaveClick}>Save</Button>
      </div>
    </>
  );
};
